"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _isNil = _interopRequireDefault(require("lodash/fp/isNil"));
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _InputClearButton = _interopRequireDefault(require("../InputClearButton"));
var _MenuContext = require("../Menu/MenuContext");
var _excluded = ["defaultValue", "className", "style", "onChange", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var isControlled = function isControlled(value, onChange) {
  return !(0, _isNil["default"])(value) && (0, _isFunction["default"])(onChange);
};
var MenuSearchInput = function MenuSearchInput(_ref, ref) {
  var _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
    className = _ref.className,
    style = _ref.style,
    onChange = _ref.onChange,
    value = _ref.value,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_MenuContext.MenuContext),
    searchText = _useContext.searchText,
    onSearchTextChange = _useContext.onSearchTextChange;
  var getValue = function getValue() {
    return isControlled(value, onChange) ? value : searchText;
  };
  var syncUpDefaultValue = function syncUpDefaultValue() {
    if (defaultValue) {
      onSearchTextChange === null || onSearchTextChange === void 0 || onSearchTextChange(defaultValue);
    }
  };
  (0, _react.useEffect)(syncUpDefaultValue, [defaultValue, onSearchTextChange]);
  var handleChange = (0, _react.useCallback)(function (e) {
    if (isControlled(value, onChange)) {
      onChange === null || onChange === void 0 || onChange(e.target.value);
    } else {
      onSearchTextChange === null || onSearchTextChange === void 0 || onSearchTextChange(e.target.value);
    }
  }, [value, onChange, onSearchTextChange]);
  var handleClear = (0, _react.useCallback)(function () {
    if (isControlled(value, onChange)) {
      onChange === null || onChange === void 0 || onChange('');
    } else {
      onSearchTextChange === null || onSearchTextChange === void 0 || onSearchTextChange('');
    }
  }, [value, onChange, onSearchTextChange]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('menu-search', className),
    "data-testid": "menu-search-input-root",
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "menu-search-input"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "ic-search",
    "aria-hidden": "true"
  }), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({
    ref: ref,
    type: "text",
    "data-testid": "menu-search-input",
    onChange: handleChange,
    value: getValue()
  }, rest)), !!getValue() && /*#__PURE__*/_react["default"].createElement(_InputClearButton["default"], {
    className: "menu-search-clear-btn",
    "data-testid": "menu-search-clear-btn",
    onClear: handleClear
  })));
};
var Composed = (0, _compose["default"])(_react.memo, _react["default"].forwardRef)(MenuSearchInput);
var _default = exports["default"] = Composed;